import landingLayout from '@/modules/saryahLanding/components/landing-layout.vue';
const PrivacyPolicyPage = () =>
  import(
    '@/modules/saryahLanding/components/privacy-policy.vue'
  );
const TermsAndConditionsPage = () =>
  import(
    '@/modules/saryahLanding/components/terms-conditions.vue'
  );

// import PrivacyPolicyPage from '@/modules/saryahLanding/components/privacy-policy-page.vue';
// import App from '@/app.vue'
// // import { i18n } from '@/i18n';
// import main from '@/main';
// import VueMeta from 'vue-meta'

import { storeAsync } from '@/app-module';
// const store = storeAsync();

import { getLanguages, setLanguageCode } from '@/i18n';
const languages = getLanguages().map((lang) => lang.id);
console.log('languages : ', languages);
import i18n from '@/vueI18n';

export default [
  {
    name: '',
    path: '/:lang?',
    component: landingLayout,
    beforeEnter(to, from, next) {
      // document.title = to.meta.title
      //
      let lang = to.params.lang;
      if (languages.indexOf(lang) != -1) {
        if (localStorage.getItem('language') !== lang) {
          setLanguageCode(lang);
          storeAsync().dispatch(
            'saryahLanding/landing/changeCurrentLanguageCode',
            lang,
          );
        }
        i18n.locale = lang;
        return next();
      }
      lang = localStorage.getItem('language') || 'ar';
      i18n.locale = lang;
      const path = to.params.lang
        ? to.path.replace(to.params.lang, lang)
        : lang;

      document.title =
        i18n.t('app.title') + ' | ' + i18n.t('meta.title');

      return next({ path: path });
      // return next({ path: lang })
      // return next({ path: `/${lang}${to.path}` })
    },
  },

  {
    name: 'privacy-policy',
    path: '/:lang?/privacy-policy',
    component: PrivacyPolicyPage,
    beforeEnter(to, from, next) {
      document.title =
        i18n.t('app.title') +
        ' | ' +
        i18n.t('common.privacyPolicy');
      let lang = to.params.lang;
      if (languages.indexOf(lang) != -1) {
        if (localStorage.getItem('language') !== lang) {
          setLanguageCode(lang);
          storeAsync().dispatch(
            'saryahLanding/landing/changeCurrentLanguageCode',
            lang,
          );
        }
        i18n.locale = lang;
        return next();
      }
      lang = localStorage.getItem('language') || 'ar';
      i18n.locale = lang;
      const path = to.params.lang
        ? to.path.replace(to.params.lang, lang)
        : lang;
      return next({ path: path });
    },
  },
  {
    name: 'terms-and-conditions',
    path: '/:lang?/terms-and-conditions',
    component: TermsAndConditionsPage,
    beforeEnter(to, from, next) {
      // document.title = to.meta.title
      document.title =
        i18n.t('app.title') +
        ' | ' +
        i18n.t('common.termsAndConditions');
      let lang = to.params.lang;
      if (languages.indexOf(lang) != -1) {
        if (localStorage.getItem('language') !== lang) {
          setLanguageCode(lang);
          storeAsync().dispatch(
            'saryahLanding/landing/changeCurrentLanguageCode',
            lang,
          );
        }
        i18n.locale = lang;
        return next();
      }
      lang = localStorage.getItem('language') || 'ar';
      i18n.locale = lang;
      const path = to.params.lang
        ? to.path.replace(to.params.lang, lang)
        : lang;
      return next({ path: path });
    },
  },

  // {
  //   path: '/:lang',
  //   component: App,
  //   beforeEnter(to, from, next) {
  //     // console.log('To => ', to)
  //     // console.log('Next => ', next)
  //     let lang = to.params.lang
  //     // console.log('lang', lang)
  //     // if (languages.includes(lang)) {
  //     if (languages.indexOf(lang) != -1) {
  //       if (localStorage.getItem('language') !== lang) {
  //         setLanguageCode(lang)
  //         document.location.reload(false);
  //       }
  //       return next()
  //     }
  //     return next({ path: localStorage.getItem('language') })
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'landingLayout',
  //       component: landingLayout
  //     },
  //     {
  //       name: 'privacy-policy',
  //       path: 'privacy-policy',
  //       component: PrivacyPolicyPage,
  //     },

  //     // {
  //     //   path: 'about',
  //     //   name: 'about',
  //     //   component: PrivacyPolicyPage
  //     // }
  //   ]
  // }
];
